import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getAllDatasets } from "../../store/selectors/datasets";
import { DatasetWrapper, ImportedFilesContainer } from "../NewProject/styles";
import { requestGetAllDatasets } from "../../store/slices/datasets";
import { DatasetModalListItem } from "../DatasetModalListItem";
import { FileLibraryItem } from "../../models/Files";

type DatasetLibraryType = {
  setDimensionsSelected: Dispatch<SetStateAction<any>>;
  setFileOverviewOpen: Dispatch<SetStateAction<boolean>>;
  searchInput: string;
};

interface IFilesWithSelectedProp extends FileLibraryItem {
  checkboxState: "checked" | "indeterminate" | "none";
}

export const DatasetLibraryList = ({
  setFileOverviewOpen,
  setDimensionsSelected,
  searchInput,
}: DatasetLibraryType) => {
  const dispatch = useDispatch();
  const { items: datasets } = useSelector(getAllDatasets);
  const [dataSetList, setDataSetList] = useState<IFilesWithSelectedProp[]>(
    datasets.map((item) => ({ ...item, checkboxState: "none" }))
  );

  useEffect(() => {
    setDataSetList(
      datasets.map((item) => ({ ...item, checkboxState: "none" }))
    );
  }, [datasets]);

  const filteredDatasets = dataSetList
    .filter((item) =>
      item.name.toLowerCase().includes(searchInput.toLowerCase())
    )
    // @ts-ignore
    .sort((a, b) => new Date(b?.updatedAt) - new Date(a?.updatedAt));

  useEffect(() => {
    dispatch(requestGetAllDatasets({}));
  }, [dispatch]);

  return (
    <DatasetWrapper $full>
      <ImportedFilesContainer $noGap>
        {filteredDatasets.map((dataSet) => (
          <DatasetModalListItem
            file={dataSet}
            key={dataSet.id + dataSet.name}
            setFileOverviewOpen={setFileOverviewOpen}
            isChecked={dataSet.checkboxState}
            onChange={(value: "checked" | "indeterminate" | "none") => {
              setDataSetList((prev) =>
                prev.map((prevItem) =>
                  prevItem.id === dataSet.id
                    ? { ...prevItem, checkboxState: value }
                    : prevItem
                )
              );
            }}
            setDimensionsSelected={setDimensionsSelected}
          />
        ))}
      </ImportedFilesContainer>
    </DatasetWrapper>
  );
};
